import { AxiosError, AxiosResponse } from 'axios';

interface NotifyToSlackChannelProps<T = string> {
  webHookURL: string;
  message: T;
  channel?: string;
  username?: string;
  botIconURL?: string;
}

export const notifyToSlackChannel = <T = string>({
  webHookURL,
  message,
  channel,
  username,
  botIconURL,
}: NotifyToSlackChannelProps<T>): Promise<AxiosResponse | AxiosError | null> => {
  if (!webHookURL || !webHookURL.trim() || !message) {
    return Promise.resolve(null);
  }

  const payload = {
    attachments: message,
    channel: channel?.trim() || '',
    username: username?.trim() || '',
    icon_url: botIconURL?.trim() || '',
  };

  return fetch(webHookURL, {
    method: 'post',
    body: JSON.stringify(payload),
  })
    .then((response) => response)
    .catch((error) => error);
};
